// extracted by mini-css-extract-plugin
module.exports = {"table-header":"HeaderRow_table-header__wQ8UY","editing-pricing":"HeaderRow_editing-pricing__1rIc6"};